@if (operations === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading track operations...
	</div>
}

@if (operations && !operations.length) {
	<div class="loading-status">
		No operations with track data are available
	</div>
}

@if (operations && operations.length > 0) {
	<div class="row">
		<div class="col-lg-6">
			<div class="panel">
				<div class="heading">Operations</div>
				<div class="content">
					<div class="row">
						<label class="col-md-4 col-form-label">Before operation:</label>
						<div class="col-md-8">
							<select class="form-control form-control-sm" [(ngModel)]="opBefore" (ngModelChange)="updatePlot()"
								[title]="operations | operationslimitnote : 'track' : rotor.rotorid">
								@for (operation of operations; track operation) {
									<option [ngValue]="operation">
										{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0)}}
									</option>
								}
							</select>
						</div>
					</div>
					<div class="row">
						<label class="col-md-4 col-form-label">After operation:</label>
						<div class="col-md-8">
							<select class="form-control form-control-sm" [(ngModel)]="opAfter" (ngModelChange)="updatePlot()"
								[title]="operations | operationslimitnote : 'track' : rotor.rotorid">
								@for (operation of operations; track operation) {
									<option [ngValue]="operation">
										{{operation | operationlabel : (fleet ? fleet.time_offset_hours : 0)}}
									</option>
								}
							</select>
						</div>
					</div>
				</div>
			</div>
			@if (rotor && adjustments) {
				<div class="panel">
					<div class="heading">Adjustments</div>
					<div class="content">
						<app-adjustment-grid [rotor]="rotor" [adjustments]="adjustments" [reorderHeaderForClockwise]="true"></app-adjustment-grid>
					</div>
				</div>
			}
			@if (rotor.balancedata && rotor.balancedata.numblades >= 4 && !rotor.balancedata.oneperrev) {
				<app-shaft-order [(shaftOrder)]="shaftOrder" (refresh)="updateBothPlots()"></app-shaft-order>
			}
			<div class="row mt-3">
				<div class="col-lg-6">
					<app-action-button [action]="CalculateCoefficients" [context]="this" processing="Calculating..." complete="Complete">Calculate Coefficients</app-action-button>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="panel">
				<div class="heading">Blade track</div>
				<div class="content">
					<app-dvs-chart [options]="trackOptions" [height]="'400px'" [error]="errormessage"></app-dvs-chart>
					@if (trackOptions) {
						<div class="chart-legend">
							<span class="legend-item">
								<span class="swatch diamond"></span> Before Averages
							</span>
							<span class="legend-item">
								<span class="swatch square"></span> After Averages
							</span>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
}
@if (coefficientText) {
	<div id="coefficient-results" class="panel">
		<div class="heading">Result</div>
		<div class="content">
			<textarea [(ngModel)]="coefficientText" class="form-control" style="min-height: 400px;" readonly></textarea>
		</div>
	</div>
}
@if (operations && operations.length > 0) {
	<div class="panel">
		<div class="heading">Track Split</div>
		<div class="content">
			<app-dvs-chart [options]="timelineOptions" loading="Loading track data" [height]="'300px'"></app-dvs-chart>
			@if (timelineOptions && adjustments && adjustments.length) {
				<div class="chart-legend">
					<span class="legend-item">
						<span class="swatch adjustment"></span> Adjustment
					</span>
				</div>
			}
		</div>
	</div>
}